/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react-hooks/exhaustive-deps */
import { ErrorMessage } from '@hookform/error-message';
import { consumirServicioEncirptacion } from 'api';
import BreadCurmb from 'components/BreadCrumbMex/BreadCrumb';
import {
  emailRegex,
  inputNumericoEnteros,
  required,
} from 'components/InputsMex/validaciones';
import Page from 'components/Page';
import { IndexColumn } from 'components/Table/Columns';
import { urlCertificadosCreacionMasiva } from 'constants/urls';
import useCustomRouter from 'hooks/useCustomRouter';
import useCustomToast from 'hooks/useCustomToasts';
import useExcelToJson from 'hooks/useExcelToJson';
import useUsuario from 'hooks/useUsuario';
import _ from 'lodash';
import moment from 'moment';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useParams } from 'react-router';
import useDetallePoliza from 'redux/hooks/useDetallePoliza';
import * as uuid from 'uuid';
import Loading from 'wrappers/Loading';
import { StyledInput } from './styleds';

const dateMapper = (value) => {
  const momentValue = moment(value);
  if (!momentValue.isValid()) {
    return '';
  }
  return momentValue.format('yyyy-MM-DD');
};

const todayMoment = moment();

const validacionPorcentaje = {
  setValueAs: (value) => (value ? Number(value) : value),
  min: {
    value: 1,
    message: 'El mínimo es de 1',
  },
  max: {
    value: 100,
    message: 'El máximo es de 100',
  },
};

const CargaMasivaCertificadosPoliza = () => {
  const inputFileRef = useRef(null);

  const { loading, excelFileToJson } = useExcelToJson();
  const [data, setData] = useState([]);
  const { idPoliza, codPlan } = useParams();
  const [showUpload, setShowUpload] = useState(false);

  const [indexCounter, setIndexCounter] = useState(0);

  const { certificadosProps } = useDetallePoliza();

  const usuario = useUsuario();

  const { control, handleSubmit, errors, getValues, setError, clearErrors, reset } =
    useForm({
      mode: 'onChange',
    });

  const router = useCustomRouter();
  const { addWarningToast, addSuccessToast } = useCustomToast();
  const openFile = () => inputFileRef.current.click();
  const [enviando, setEnviando] = useState(false);

  const columns = useMemo(
    () => [
      {
        header: 'id',
        field: 'uuid',
        inputProps: { type: 'text' },
        mapper: () => uuid.v4(),
        hide: true,
      },
      {
        header: 'idPoliza',
        field: 'idPoliza',
        defaultValue: idPoliza,
        hide: true,
      },
      {
        header: 'codPlan',
        field: 'codPlan',
        defaultValue: codPlan,
        hide: true,
      },
      {
        header: 'nomUsuario',
        field: 'nomUsuario',
        defaultValue: usuario.fullName,
        hide: true,
      },
      {
        header: 'codusuario',
        field: 'codusuario',
        defaultValue: usuario.cliCodigoCore,
        hide: true,
      },
      {
        header: 'Pasaporte/Id/Número de empleado (Obligatorio)',
        field: 'cliIdentificacion',
        defaultValue: '',
        inputProps: { type: 'text' },
        rules: (props) => ({
          validate: required(),
          setValueAs: (value) => (value ? String(value).trim() : value),
        }),
      },
      {
        header: 'Género (Obligatorio)',
        field: 'genero',
        defaultValue: '',

        inputProps: { type: 'text' },
        rules: (props) => ({
          validate: (value) => {
            if (value !== 'M' && value !== 'F') {
              return 'Ingrese solo M o F';
            }
            return true;
          },
        }),
      },
      {
        header: 'Nombres (Obligatorio)',
        field: 'cliNombres',
        defaultValue: '',
        rules: (props) => ({
          validate: required(),
        }),
      },
      {
        header: 'Apellidos (Obligatorio)',
        field: 'cliApellidos',
        defaultValue: '',
        inputProps: { type: 'text' },
        rules: (props) => ({
          validate: required(),
        }),
      },
      {
        header: 'Fecha de nacimiento (Obligatorio)',
        field: 'fechaNac',
        defaultValue: '',
        mapper: dateMapper,
        inputProps: {
          type: 'date',
          max: certificadosProps?.validaciones?.fechaNacimiento?.minima,
          min: certificadosProps?.validaciones?.fechaNacimiento?.maxima,
          onKeyDown: (e) => e.preventDefault(),
        },
        rules: (props) => ({
          validate: required(),
        }),
      },
      {
        header: 'Código destino (Obligatorio)',
        field: 'codigoDestino',
        defaultValue: '',
        inputProps: { type: 'text' },
        rules: (props) => ({
          validate: required(),
        }),
      },
      {
        header: 'Nombre destino (Obligatorio)',
        field: 'nomDestino',
        defaultValue: '',
        inputProps: {
          type: 'text',
        },
        rules: (props) => ({
          validate: required(),
        }),
      },
      {
        header: 'Fecha inicio viaje (Obligatorio)',
        field: 'iniVigencia',
        defaultValue: '',
        mapper: dateMapper,
        inputProps: {
          type: 'date',
          min: moment().format('yyyy-MM-DD'),
          max: moment().add(10, 'years').format('yyyy-MM-DD'),
        },
        rules: ({ index }) => ({
          validate: {
            //required: required(),
            diasMax: (value) => {
              console.log('VALUE: ', value);
              if (!value) {
                return 'Campo obligatorio';
              }
              const fin = getValues(`[${index}].finVigencia`);

              if (!fin) {
                setError(`[${index}].finVigencia`, {
                  type: 'sinFin',
                  message: 'Seleccione una fecha de fin de vigencia',
                });
                return true;
              }

              const valueMoment = moment(value, 'yyyy-MM-DD');
              const finMoment = moment(fin, 'yyyy-MM-DD');

              if (valueMoment.isSame(finMoment)) {
                return 'La fecha de inicio no puede ser igual a la fecha de fin de vigencia';
              }

              if (valueMoment.isAfter(finMoment)) {
                return 'La fecha de incio no puede ser superior a la fecha de fin de vigencia';
              }

              if (finMoment.isBefore(valueMoment)) {
                return 'La fecha de fin no puede ser anterior a la fecha de inicio de vigencia';
              }

              if (valueMoment.isBefore(todayMoment, 'days')) {
                return 'La fecha ingresada no puede ser menor a la de hoy';
              }

              if (
                finMoment.diff(valueMoment, 'days') >
                certificadosProps?.validaciones.diasMaximos
              ) {
                return `Periodo máximo de ${certificadosProps?.validaciones.diasMaximos} días continuos de viaje`;
              }
              clearErrors(`[${index}].finVigencia`);

              return true;
            },
          },
        }),
      },
      {
        header: 'Fecha fin viaje (Obligatorio)',
        field: 'finVigencia',
        defaultValue: '',
        mapper: dateMapper,
        inputProps: {
          type: 'date',
          min: moment().add(1, 'days').format('yyyy-MM-DD'),
          max: moment().add(10, 'years').format('yyyy-MM-DD'),
        },
        rules: ({ index }) => ({
          validate: (value) => {
            if (!value) {
              return 'Campo obligatorio';
            }
            const inicio = getValues(`[${index}].iniVigencia`);
            if (!inicio) {
              setError(`[${index}].iniVigencia`, {
                type: 'sinFin',
                message: 'Seleccione una fecha de fin de vigencia',
              });
              return true;
            }
            const valueMoment = moment(value, 'yyyy-MM-DD');
            const inicioMoment = moment(inicio, 'yyyy-MM-DD');

            if (inicioMoment.isSame(valueMoment)) {
              return 'La fecha de inicio no puede ser igual a la fecha de fin de vigencia';
            }

            if (inicioMoment.isAfter(valueMoment)) {
              return 'La fecha de incio no puede ser superior a la fecha de fin de vigencia';
            }

            if (valueMoment.isBefore(inicioMoment)) {
              return 'La fecha de fin no puede ser anterior a la fecha de inicio de vigencia';
            }

            if (
              valueMoment.diff(inicioMoment, 'days') >
              certificadosProps?.validaciones.diasMaximos
            ) {
              return `Periodo máximo de ${certificadosProps?.validaciones.diasMaximos} días continuos de viaje`;
            }
            clearErrors(`[${index}].iniVigencia`);
          },
        }),
      },
      {
        header: 'Cargo (Obligatorio)',
        field: 'cargo',
        defaultValue: '',
        rules: (props) => ({
          validate: required(),
        }),
      },
      {
        header: 'Correo (Obligatorio)',
        field: 'cliEmail',
        defaultValue: '',
        rules: (props) => ({
          validate: required(),
          pattern: {
            value: emailRegex,
            message: 'Ingrese un correo válido',
          },
        }),
      },
      {
        header: 'Beneficiario 1 (Obligatorio)',
        field: 'listBeneficiarios[0].nombre',
        defaultValue: '',
        inputProps: { type: 'text' },
        rules: ({ index }) => ({
          validate: {
            required: required(),
          },
        }),
      },
      {
        header: 'Parentesco 1 (Obligatorio)',
        field: 'listBeneficiarios[0].parentesco',
        defaultValue: '',
        inputProps: { type: 'text' },
        rules: ({ index }) => ({
          validate: required(),
        }),
      },
      {
        header: 'Porcentaje 1 (Obligatorio)',
        field: 'listBeneficiarios[0].porcentaje',
        defaultValue: '',
        inputProps: { type: 'number', onKeyDown: inputNumericoEnteros },
        rules: ({ index }) => ({
          validate: {
            required: required(),
          },
          ...validacionPorcentaje,
        }),
      },

      //SEGUNDO BENEFICIARIO

      {
        header: 'Beneficiario 2 (Opcional)',
        field: 'listBeneficiarios[1].nombre',
        defaultValue: '',
        inputProps: { type: 'text' },
        rules: ({ index }) => ({
          validate: {
            //first: validarCamposBeneficiariosInLine(index, 1),
          },
        }),
      },
      {
        header: 'Parentesco 2',
        field: 'listBeneficiarios[1].parentesco',
        defaultValue: '',
        inputProps: { type: 'text' },
        rules: ({ index }) => ({
          validate: {
            //first: validarCamposBeneficiariosInLine(index, 1),
          },
        }),
      },
      {
        header: 'Porcentaje 2',
        field: 'listBeneficiarios[1].porcentaje',
        defaultValue: '',
        inputProps: { type: 'number', onKeyDown: inputNumericoEnteros },
        rules: ({ index }) => ({
          ...validacionPorcentaje,
          validate: {
            //first: validarCamposBeneficiariosInLine(index, 1),
          },
        }),
      },

      //TERCER BENEFICIARIO

      {
        header: 'Beneficiario 3 (Opcional)',
        field: 'listBeneficiarios[2].nombre',
        defaultValue: '',
        inputProps: { type: 'text' },
        rules: ({ index }) => ({
          validate: {
            //first: validarCamposBeneficiariosInLine(index, 2),
          },
        }),
      },
      {
        header: 'Parentesco 3',
        field: 'listBeneficiarios[2].parentesco',
        defaultValue: '',
        inputProps: { type: 'text' },
        rules: ({ index }) => ({
          validate: {
            //first: validarCamposBeneficiariosInLine(index, 2),
          },
        }),
      },
      {
        header: 'Porcentaje 3',
        field: 'listBeneficiarios[2].porcentaje',
        defaultValue: '',
        inputProps: { type: 'number', onKeyDown: inputNumericoEnteros },
        rules: ({ index }) => ({
          ...validacionPorcentaje,
          validate: {
            //first: validarCamposBeneficiariosInLine(index, 2),
          },
        }),
      },
      //CUARTO BENEFICIARIO
      {
        header: 'Beneficiario 4 (Opcional)',
        field: 'listBeneficiarios[3].nombre',
        defaultValue: '',
        inputProps: { type: 'text' },
        rules: ({ index }) => ({
          validate: {
            //first: validarCamposBeneficiariosInLine(index, 3),
          },
        }),
      },
      {
        header: 'Parentesco 4',
        field: 'listBeneficiarios[3].parentesco',
        defaultValue: '',
        inputProps: { type: 'text' },
        rules: ({ index }) => ({
          validate: {
            //first: validarCamposBeneficiariosInLine(index, 3),
          },
        }),
      },
      {
        header: 'Porcentaje 4',
        field: 'listBeneficiarios[3].porcentaje',
        defaultValue: '',
        inputProps: {
          type: 'number',
          onKeyDown: inputNumericoEnteros,
        },
        rules: ({ index }) => ({
          ...validacionPorcentaje,
          validate: {
            //first: validarCamposBeneficiariosInLine(index, 3),
          },
        }),
      },
    ],
    [certificadosProps.validaciones],
  );

  const tableColumns = useMemo(() => columns.filter((column) => !column.hide), []);

  useEffect(() => {
    if (inputFileRef?.current) {
      inputFileRef.current.addEventListener('change', ({ target }) => {
        onChangeFile(target?.files?.[0]);
      });
    }
  }, [inputFileRef.current]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const onChangeFile = (file) => {
    excelFileToJson(file, (items) => {
      reset();
      const newData = items[0].items?.map((item, index) => {
        const object = {};
        columns.forEach((column) => {
          let value = _.get(item, column.header, column.defaultValue);
          if (column.mapper) value = column.mapper(value);
          _.set(object, column.field, value);
        });

        object.index = index;
        return object;
      });

      setIndexCounter(newData.length);

      setData(newData);

      inputFileRef.current.value = null;
      setShowUpload(true);
    });
  };

  const onClickAgregar = () => {
    const newObject = {};

    columns.forEach((column) => _.set(newObject, column.field, ''));
    const newCounter = indexCounter + 1;

    newObject.index = newCounter;

    newObject.uuid = uuid.v4();

    data.push(newObject);

    setIndexCounter(newCounter);
    setData([...data]);
  };

  const onClickLimpiar = () => {
    setData([]);
    setShowUpload(false);
  };

  const onClickGuardar = async (input) => {
    const certificados = Object.entries(input)
      .map((item) => item[1])
      .map((item) => ({
        idPoliza,
        nomUsuario: usuario.fullName,
        codusuario: usuario.cliCodigoCore,
        codPlan,
        ...item,
        listBeneficiarios: item.listBeneficiarios.filter(
          (beneficiario) =>
            beneficiario.nombre !== '' &&
            beneficiario.parentesco !== '' &&
            beneficiario.porcentaje !== '',
        ),
      }));

    const Data = {
      idPoliza: idPoliza,
      codPlan: codPlan,
      certificados,
    };

    console.log('DATA: ', Data);

    setEnviando(true);

    const res = await consumirServicioEncirptacion(
      urlCertificadosCreacionMasiva,
      Data,
    );
    console.log('RES: ', res);

    if (res?.transaccion) {
      addSuccessToast(res?.certificadosGenerados);
      setEnviando(false);
      return router.push(`/detalle-poliza-plan/${idPoliza}/${codPlan}`);
    } else {
      setData([...data]);
      setEnviando(false);

      if (!res?.certificadosGenerados) {
        return router.push(`/detalle-poliza-plan/${idPoliza}/${codPlan}`);
      }
      addWarningToast(res?.certificadosGenerados);
      return reset({ ...input });
    }
  };

  const onSubmitError = (errors) => {
    console.log(errors);
  };

  return (
    <Loading>
      <main className="cr-content">
        <Page>
          <BreadCurmb title="Carga masiva" subtitle="Carga masiva" />

          <button
            className="btn btn-sm btn-primary"
            disabled={enviando}
            onClick={() => {
              router.push(`/detalle-poliza-plan/${idPoliza}/${codPlan}`);
            }}
          >
            Regresar
          </button>

          <div className="row justify-content-center">
            <div className="col-11 col-lg-10">
              <h1>Creación Masiva de Certificados</h1>
              <div className="card border">
                <div className="card-header">
                  <h5>Instrucciones</h5>
                </div>
                <div className="card-body">
                  <div className="row justify-content-center">
                    <div className="col-11 alert alert-success">
                      <h6 className="align-self-center">
                        1. Descarga la plantilla{' '}
                        <a
                          target="_blank"
                          href={certificadosProps?.plantilla}
                          className="btn btn-primary btn-sm"
                          disabled={enviando}
                        >
                          DESCARGAR PLANTILLA
                        </a>
                      </h6>
                    </div>
                    <div className="col-11 alert alert-success">
                      <h6 className="align-self-center">
                        2. Sube la plantilla con la información de los certificados.{' '}
                        <input
                          type="file"
                          style={{ display: 'none' }}
                          ref={inputFileRef}
                          readOnly
                          value={inputFileRef.current?.value}
                          defaultValue=""
                          accept=".xls,.xlsx"
                        />
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={openFile}
                          disabled={loading || enviando}
                        >
                          SELECCIONAR ARCHIVO
                        </button>
                      </h6>
                    </div>

                    {showUpload && (
                      <React.Fragment>
                        <div className="col-11 alert alert-success">
                          <h6 className="align-self-center">
                            3. Revisa la información ingresada, puedes agregar,
                            editar o eliminar los registros.
                          </h6>
                        </div>
                        <div className="col-11 alert alert-success">
                          <h6 className="align-self-center">
                            4. Guarda tus cambios{' '}
                            <button
                              className="btn btn-primary btn-sm"
                              onClick={handleSubmit(onClickGuardar, onSubmitError)}
                              disabled={enviando}
                            >
                              {!enviando && 'Guardar certificados'}
                              {enviando && 'Guardando certificados...'}
                            </button>
                          </h6>
                        </div>
                      </React.Fragment>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {showUpload && (
              <React.Fragment>
                <div className="col-11 col-lg-10">
                  <div className="card border">
                    <div className="card-header">
                      <button
                        className="btn btn-primary btn-sm ml-2 my-1"
                        onClick={onClickAgregar}
                        disabled={enviando}
                      >
                        Agregar certificado
                      </button>
                      <button
                        className="btn btn-sm btn-primary ml-2 my-1"
                        onClick={onClickLimpiar}
                        disabled={enviando}
                      >
                        Limpiar información
                      </button>
                    </div>
                  </div>
                </div>

                <div className="col-12">
                  <DataTable
                    value={data}
                    className="p-datatable-gridlines p-datatable-sm"
                    rowHover
                    emptyMessage="No hay certificados registrados"
                    resizableColumns
                    //autoLayout
                    paginator
                    rows={25}
                    rowsPerPageOptions={[25, 50, 75]}
                    loading={enviando}
                  >
                    {IndexColumn({
                      styles: { padding: '0.5rem 0.5rem 0.5rem 0.5rem' },
                    })}

                    {tableColumns.map((column, index) => (
                      <Column
                        key={index}
                        header={column.header}
                        headerStyle={{ width: '200px' }}
                        {...column.columnProps}
                        body={(rowData) => {
                          const name = `[${rowData.index}].${column.field}`;
                          let rules = {};
                          try {
                            rules = column.rules({
                              name,
                              index: rowData.index,
                              field: column.field,
                            });
                          } catch (error) {}
                          return (
                            <React.Fragment>
                              <Controller
                                name={name}
                                defaultValue={_.get(rowData, column.field, '')}
                                control={control}
                                rules={rules}
                                render={({ onChange, value, ref }, { invalid }) => {
                                  return (
                                    <StyledInput
                                      value={value}
                                      placeholder={column.header}
                                      onChange={({ target }) => {
                                        onChange(target.value);
                                      }}
                                      ref={ref}
                                      invalid={invalid}
                                      {...column.inputProps}
                                    />
                                  );
                                }}
                              />

                              <ErrorMessage
                                errors={errors}
                                name={name}
                                render={({ message }) => (
                                  <p className="p-invalid">{message}</p>
                                )}
                              />
                            </React.Fragment>
                          );
                        }}
                      />
                    ))}

                    <Column
                      header="Eliminar"
                      headerStyle={{ width: '200px' }}
                      body={(rowData) => (
                        <button
                          className="btn btn-block btn-primary btn-sm"
                          style={{ height: '40px' }}
                          onClick={() => {
                            const resData = data?.filter(
                              (item) => item.uuid !== rowData.uuid,
                            );
                            if (resData.length === 0) {
                              setShowUpload(false);
                            }
                            setData(resData);
                          }}
                        >
                          Eliminar
                        </button>
                      )}
                    />
                  </DataTable>
                </div>
              </React.Fragment>
            )}
          </div>
        </Page>
      </main>
    </Loading>
  );
};

export default CargaMasivaCertificadosPoliza;
